module.exports = __webpack_public_path__ + "media/images/div_lens/inclusive-img2-5446b78148775ff8fd914a2f08767a01.jpg";